import PropsAlign from './PropsAlign';
import TextParagraphs from './TextParagraphs';
import DimensionsPositions from './DimensionsPositions';
import MarginsPaddings from '../Props/MarginsPaddings';
import Headings from './Headings';
import Styles from './Styles';
import Lists from './Lists';
import Carousel from './Carousel'

const propPanels = {
    PropsAlign, TextParagraphs,
    DimensionsPositions, MarginsPaddings,    
    Headings, Styles, Lists, Carousel
};

export default propPanels;